export var oShovel = InheritO(CPlants, {
	EName: "oShovel",
	CName: "Shovel",
	width: 130,
	height: 114,
	beAttackedPointR: 70,
	PicArr: ["images/interface/Shovel/ShovelCard.png", "images/interface/Shovel/0.gif"],
	Tooltip: "Shovel up plants you don't want!",
});
